import { render, staticRenderFns } from "./top-tickets.vue?vue&type=template&id=3a30bbf3"
var script = {}
import style0 from "./top-tickets.vue?vue&type=style&index=0&id=3a30bbf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports